<template>
  <div class="page">
    <header-bar slot="head">
      <span slot="left">{{ $t("mall_modules_editrole_fanhui") }}</span>
      <span>账户授权协议</span>
    </header-bar>
    <div class="page-content" style="background-color: #FFF;text-align:left;" ref="contractContent">
      <div style="width: 94%; margin: 0 auto;">
        <h2 style="text-align:center;">账户授权协议</h2>
        <pre>
力程火车票服务由<b>青岛景行科技有限公司</b>运营，《账户授权协议》（以下简称“本协议）是<b>青岛景行科技有限公司</b>（以下称“我司”）与用户（或称“您”）订立的有效合约。在使用本协议约定的技术服务之前，请您（即用户）仔细阅读下述协议条款。一旦您点击确认本协议，即表示您已接受了以下所述的条款和条件，同意受本协议约束。如果您不同意接受全部的条款和条件，请勿使用本协议约定的技术服务。
<h3>第一条服务说明</h3>1.1通过力程预订火车票时，您可以通过您本人的12306账户和密码登陆中国铁路12306网站（www.12306.cn，以下简称“铁路官方网站”或“12306”）进行预订。您可自由选择由您手动输入账户、密码信息登录12306账号或者由您授权我司记住账户、密码自动操作。
<b>1.2如您尚未注册12306账号，您可以选择授权我司使用您提供或确认的姓名、手机号、身份证件信息、用户名、密码、邮箱地址等信息代您注册12306账号。</b>
1.3为了更好地给您提供火车票代订服务，一旦您选择使用您的12306账号预订车票，您同意将您的12306账户和密码提供给我司，授权我司使用您的12306账户和密码登陆，并在您的委托下完成火车票预订及其相关退改签、激活12306会员、会员信息查询及积分代理兑换车票等操作。
1.4如您接受此协议，代表您自愿委托使用我的12306乘客进行购票。您同意我司查询、使用、留存您提供的12306账号内的12306乘客信息代您进行火车票预订及其相关改签等操作。
<h3>第二条各方权利和义务</h3>2.1我司提供的是火车票代订服务，您接受本协议，意味着您同意我们使用您填写的账号信息和乘客信息进行代订，同时您必须遵守12306的购票规定的服务条款（https:
2.2您了解并同意，我司会根据您的授权使用您的12306账户及密码操作代订事宜，为了后续进一步向您提供服务，也会在系统中记录您的前述相关信息。但是对于您的个人信息及相关交易信息，我司会严格保护，不做其他与火车票服务无关的用途。
2.3您同意在每次使用本服务并登陆您的12306账户后将账户中的历史订单同步到我司，用于您进一步的查询和操作。
2.4我司可根据国家法律法规变化及维护交易秩序、保护消费者权益需要，不时修改本协议，并通过平台进行公示。
2.5本协议下的技术服务暂不向用户收取技术服务费，但我司保留收费的权利。
<h3>第三条其他</h3>3.1如您对本服务有异议，您可以通过我们的在线客服或官方热线<b>400888020</b>进行咨询，我司将根据您的要求向您解释和说明，或根据您的要求停止提供上述服务和信息使用。
3.2因解释本服务协议或使用本服务而导致的争议，用户及<b>青岛景行科技有限公司</b>均同意接受上海市长宁区人民法院的管辖。
3.3本协议未尽事宜以我司与您签署的《火车票服务协议》及力程平台内相关协议和规则为准。
      </pre
        >
      </div>
    </div>
  </div>
</template>
<style scoped>
pre {
    white-space: pre-wrap;
    word-wrap: break-word;
    font-size: 0.38rem;
  }
  .header-menu header {
    background-color: #12a3ff;
  }
  .page-content {
    top: 2.12rem;
  }
  pre h3{
  margin-bottom: 0;
  }
</style>
<script>
  import navBar from "../../system/modules/navBar.vue";
  export default {
    name: "about",
    data() {
      return {};
    },
    components: {
      navBar,
    },
  };
</script>
